module.exports = __webpack_public_path__ + "static/borrowBanner-b890a3ba91d805b4e5343853fe676e3f.svg";